<template>
    <div id="app">
        <van-notice-bar mode="closeable" color="#1989fa" background="#ecf9ff">
            <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
                <van-swipe-item>如何打印准考证：考试查看/打印准考证等信息，请在报名系统首页输入报名序号及身份证号码，点击查询报名状态按钮，在报名状态页面根据提示完成操作即可。</van-swipe-item>
                <van-swipe-item>报名序号是报考人员查询报考资格审核结果、网上缴费、下载打印准考证和查询成绩等事项的重要依据，请务必妥善留存。</van-swipe-item>
                <van-swipe-item>报名成功后，会通过报名时填写的手机号以短信的形式下发报名序号，请注意查收。</van-swipe-item>
            </van-swipe>
        </van-notice-bar>
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'app'
}
</script>
<style>
* {
    padding: 0;
    margin: 0;
}

body {
    font-family: 'PingFang SC', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#app {
    height: 100vh;
}
.van-notice-bar {
    position: absolute !important;
    width: 100%;
}
.van-notice-bar__wrap {
    justify-content: center;
}
.notice-swipe {
    height: 40px;
    line-height: 40px;
}

#watermark {
    position: relative;
    z-index: 999;
    overflow: hidden;
}
.plisttable {
    padding: 10px;
    margin-top: 12px;
    margin-bottom: 25px;
    min-height: 380px;
    border-radius: 10px;
}
::-webkit-scrollbar {
    width: 7px;
    height: 4px;
    background-color: #f5f5f5;
}

/* .button.is-small {
    font-size: 0.9rem !important;
} */

.tag {
    font-size: 0.9rem !important;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: #fff;
}

::-webkit-scrollbar-thumb {
    border-radius: 3px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(158, 158, 158, 0.7);
}

::-webkit-scrollbar-thumb:hover {
    border-radius: 3px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(158, 158, 158, 1);
}
</style>
